import { createPerfilApiClient } from './perfilApiClient';

export default {
    /**
     * Obtiene la información de pago (tarjeta guardada).
     * Admin: GET /usuarios/{userId}/info_pago
     * Front: POST /f/perfil/info_pago
     *
     * @param {Object} options
     * @param {string} options.tid
     * @param {number} [options.userId]
     * @param {boolean} [options.admin=false]
     * @returns {Promise<Object>} response con data: { titular, panVuePayCard, mesCaducidad, anoCaducidad }
     */
    async getInfoPago({ tid, userId, admin = false }) {
        const token = localStorage.getItem('token');
        const client = createPerfilApiClient();

        if (admin) {
            return client.get(`/usuarios/${userId}/info_pago`, {
                params: { filters: {}, tid, api_key: token },
            });
        }

        return client.post('/f/perfil/info_pago', {
            tid,
            filters: {},
            api_key: token,
        });
    },

    /**
     * Obtiene el JetID para el formulario Paycomet.
     * Admin: POST /usuarios/{userId}/get_jet_id
     * Front: POST /f/perfil/get_jet_id
     *
     * @param {Object} options
     * @param {string} options.tid
     * @param {number} [options.userId]
     * @param {boolean} [options.admin=false]
     * @returns {Promise<Object>} response con data: { jet_id }
     */
    async getJetId({ tid, userId, admin = false }) {
        const token = localStorage.getItem('token');
        const client = createPerfilApiClient();
        const base = admin ? `/usuarios/${userId}` : '/f/perfil';

        return client.post(`${base}/get_jet_id`, {
            tid,
            filters: {},
            api_key: token,
        });
    },

    /**
     * Procesa la confirmación de la tarjeta (token Paycomet).
     * Admin: POST /usuarios/{userId}/procesar-confirmacion-tarjeta
     * Front: POST /f/perfil/paycomet/procesar-confirmacion-tarjeta
     *
     * @param {Object} options
     * @param {string} options.tid
     * @param {string} options.jetToken
     * @param {number} [options.userId]
     * @param {boolean} [options.admin=false]
     * @returns {Promise<Object>} response con data: { response: { challengeUrl?, compraFinalizada? } }
     */
    async procesarConfirmacionTarjeta({ tid, jetToken, userId, admin = false }) {
        const token = localStorage.getItem('token');
        const client = createPerfilApiClient();
        const base = admin ? `/usuarios/${userId}` : '/f/perfil/paycomet';

        return client.post(`${base}/procesar-confirmacion-tarjeta`, {
            filters: {},
            jetToken,
            tid,
            api_key: token,
        });
    },
};
